import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { reduxForm, Form } from 'redux-form';

import { handleAddressChange } from 'checkout/checkout/common/helpers';
import AddressForm from 'common/components/address/AddressForm';
import {
  transformAddressData,
  initialFormValues
} from 'common/components/address/helpers';
import { FormError, Button } from 'common/components/layout';
import { getDefaultCountryCode, removeSpaces } from 'common/helpers/miscHelper';
import {
  integerFormat,
  convertStringToInteger
} from 'common/helpers/numberHelper';
import CreditCardForm from 'profile/creditCard/components/CreditCardForm';
import { updateAndChargePayGate } from 'redux/cart/actions';
import { listCustomerAddresses } from 'redux/customerAddresses/actions';

import PayGateHiddenForm from './PayGateHiddenForm';
import AddressPicker from './components/AddressPicker';
import {
  validateAddressForLoggedInCustomer,
  validateCreditCard
} from './validators';

class Payment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSaveAddress: true,
      isSubmitting: false,
      redirect: null
    };
  }

  componentDidMount() {
    const { props } = this;
    props.listCustomerAddresses();
  }

  handleSubmit = (form) => {
    const { props, state } = this;
    this.setState({ isSubmitting: true });
    const data = transformData(form);
    const successFunction = (order) => {
      props.history.push(`/checkout/receipt/${order.id}`);
    };
    const redirectFunction = (response) => {
      this.setState({ redirect: response });
    };
    const errorFunction = () => {
      this.setState({ isSubmitting: false });
    };
    const { isSaveAddress } = state;
    props.updateAndChargePayGate(
      data.address,
      data.creditCard,
      isSaveAddress,
      successFunction,
      redirectFunction,
      errorFunction
    );
  };

  handleAddressChange = (e) => {
    const { props } = this;
    const addressId = e.target.value;
    let address;
    if (addressId) {
      address = props.customerAddresses.data[addressId];
    }
    handleAddressChange(addressId, address, props.change, props.settings);
  };

  handleBack = (e) => {
    e.preventDefault();
    const { props } = this;
    props.onEdit('customer');
  };

  handleSaveAddress = (e) => {
    this.setState({ isSaveAddress: e.target.checked });
  };

  render() {
    const { cart, handleSubmit, change, form, settings } = this.props;
    const { customerAddresses } = this.props;
    const { isSaveAddress, isSubmitting, redirect } = this.state;
    let object = { countryCode: getDefaultCountryCode(settings) };
    if (cart.shipTo) {
      object = cart.shipTo;
    }
    if (redirect) {
      return <PayGateHiddenForm redirect={redirect} />;
    }
    return (
      <Form
        onSubmit={handleSubmit(this.handleSubmit)}
        className="c7-form"
        method="post"
      >
        <FormError formName={form} />
        <h3>Payment method</h3>
        <p>All transactions are secure and encrypted.</p>
        <CreditCardForm />

        <p>&nbsp;</p>
        <h3>Billing address</h3>
        <AddressPicker
          customerAddresses={customerAddresses.data}
          onAddressChange={this.handleAddressChange}
        />
        <AddressForm
          object={object}
          changeFunction={change}
          settings={settings}
        />
        <div>
          <label htmlFor="saveAddress">
            <input
              type="checkbox"
              name="saveAddress"
              onChange={this.handleSaveAddress}
              value
              checked={isSaveAddress}
            />
            Save this information
          </label>
        </div>

        <div className="c7-checkout__content__buttons">
          <Button type="submit" className="c7-button" disabled={isSubmitting}>
            Complete Order
          </Button>
          <a
            href="#"
            aria-label="Return to cutomer information"
            onClick={this.handleBack}
          >
            Return to customer information
          </a>
        </div>
      </Form>
    );
  }
}

const transformData = (values) => {
  let creditCard;
  const address = transformAddressData(values);
  address.customerAddressId = values.customerAddressId;
  if (!values.customerCreditCardId || values.customerCreditCardId === '') {
    creditCard = {
      cardNumber: values.cardNumber && removeSpaces(values.cardNumber),
      expiryMo: values.expiryMo && integerFormat(values.expiryMo),
      expiryYr: values.expiryYr && integerFormat(values.expiryYr),
      cvv2: values.cvv2,
      cardHolderName: values.cardHolderName
    };
  } else {
    creditCard = {
      customerCreditCardId: values.customerCreditCardId
    };
  }
  return { address, creditCard };
};

const validate = (values, props) => {
  let errors = {};
  const { address } = transformData(values);
  address.birthDay = values.birthDay && convertStringToInteger(values.birthDay);
  address.birthMonth =
    values.birthMonth && convertStringToInteger(values.birthMonth);
  address.birthYear =
    values.birthYear && convertStringToInteger(values.birthYear);
  errors = Object.assign(
    errors,
    validateAddressForLoggedInCustomer(address, props.settings)
  );
  if (!values.customerCreditCardId || values.customerCreditCardId === '') {
    const { creditCard } = transformData(values);
    errors = Object.assign(errors, validateCreditCard(creditCard));
  }
  return errors;
};

const mapStateToProps = (state) => {
  let initialValues;
  let selectedCreditCardId;
  if (state.cart && state.cart.data) {
    const { billTo } = state.cart.data;
    initialValues = initialFormValues(billTo);
    const { tenders } = state.cart.data;
    if (tenders.length > 0) {
      const { creditCard } = tenders[0];
      initialValues.customerCreditCardId = creditCard.customerCreditCardId;
      selectedCreditCardId = creditCard.customerCreditCardId;
    }
  }
  return {
    cart: state.cart,
    customer: state.customer,
    settings: state.setting,
    customerAddresses: state.customerAddress,
    customerCreditCards: state.customerCreditCard,
    initialValues,
    selectedCreditCardId
  };
};

Payment = reduxForm({
  form: 'paymentLoggedInPickup',
  enableReinitialize: true,
  onSubmitFail: (err, dispatch) => {
    dispatch({ type: 'ADD_FORM_ERROR', payload: err });
  },
  onSubmitSuccess: (result, dispatch) => {
    dispatch({ type: 'REMOVE_FORM_ERROR' });
  },
  validate
})(Payment);

export default withRouter(
  connect(mapStateToProps, {
    updateAndChargePayGate,
    listCustomerAddresses
  })(Payment)
);
